export const getRoleName = (roleLevel) => {
    switch (roleLevel) {
        case 6: return '관리자';
        case 5: return '스탭';
        case 4: return '멘토';
        case 3: return '교사';
        case 2: return '학습자';
        case 1: return '일반 사용자';
        default: return '권한 없음';
    }
};

// 권한 레벨 상수 정의 (PROJECT_GUIDELINES.md 준수)
export const ROLE_LEVELS = {
    ADMIN: 6,
    STAFF: 5,
    INSTRUCTOR: 4,
    TEACHER: 3,
    LEARNER: 2,
    USER: 1
};

// role을 roleLevel로 변환하는 함수
export const getRoleLevelFromRole = (role) => {
    const roleLevels = {
        'admin': ROLE_LEVELS.ADMIN,
        'staff': ROLE_LEVELS.STAFF,
        'instructor': ROLE_LEVELS.INSTRUCTOR,
        'teacher': ROLE_LEVELS.TEACHER,
        'learner': ROLE_LEVELS.LEARNER,
        'student': ROLE_LEVELS.LEARNER,  // student도 learner로 매핑
        'user': ROLE_LEVELS.USER
    };
    return roleLevels[role] || ROLE_LEVELS.USER;  // 기본값 1
};

// 권한 체크 헬퍼 함수
export const hasMinimumRole = (userRole, requiredRole) => {
    return userRole >= requiredRole;
}; 